'use strict';

angular.module('admin.iframe', [
    'ng-komondor-resource-view',
])

.config(function (resourceStateProvider)
{
    resourceStateProvider
    .state('admin.iframes', {
        url: 'iframes',
        model: 'Iframe',
        viewOptions: 'iframeViewOptions',
        title: 'Iframes',
        modelNameField: 'slug',
        edit: {
            templateUrl: 'admin/iframe/iframe.edit.html',
            controller: 'IframeAdminCtrl',
        },
    });
})

.factory('iframeViewOptions', function (
    extendDeep,
    resourceViewOptions,
    listNameTemplate,
    listView
) {
    return extendDeep(angular.copy(resourceViewOptions), {
        queryDefaults: {
            sort: [
                ['id', 'DESC'],
            ],
        },
        list: {
            columns: [
                {
                    label: 'Slug',
                    name: 'slug',
                    sortable: true,
                },
                {
                    label: 'Enabled',
                    name: 'enabled',
                    template: '<span class="no-wrap">{{ model.enabled ? "Yes" : "No"}}</span>',
                    sortable: true,
                },
                {
                    label: 'Url',
                    name: 'video_url',
                    template: '<span class="no-wrap"><a target="_blank" href="{{model.view_url}}">{{model.view_url}}</a></span>',
                    sortable: false,
                },
                {
                    label: 'Last modified',
                    name: 'updated_at',
                    template: '<span class="no-wrap">{{ model.updated_at | date }}</span>',
                    sortable: true,
                },
            ],
        },
        views: [listView],
    });
});
